import { startVhs } from './shared/vhs.js';
import { runSplash } from './shell/splash.js';
import { createShell } from './shell/Shell.js';
import './shell/shell.css';

async function boot() {
  const app = document.getElementById('app');
  if (!app) return;

  // Analytics (skip localhost)
  if (
    location.hostname !== 'localhost' &&
    location.hostname !== '127.0.0.1'
  ) {
    const a = document.createElement('script');
    a.src = '/analytics.js';
    document.head.appendChild(a);
  }

  const splashTarget = runSplash(app);
  let splashSeen = false;
  try {
    splashSeen = !!sessionStorage.getItem('nt-splash-done');
  } catch (_) {
    // sessionStorage can throw in storage-restricted browsers — fall back
    // to always showing the intro rather than breaking boot entirely.
  }
  startVhs({ intro: !(location.pathname.split('/').filter(Boolean).length || splashSeen) });

  const fromSplash = await splashTarget;
  if (fromSplash) {
    history.replaceState({}, '', `/${fromSplash}`);
  }

  await createShell(app);
}

boot().catch((err) => {
  console.error('Noise Table boot failed', err);
});
